import { render, staticRenderFns } from "./ProductsStock.vue?vue&type=template&id=7eec5264"
import script from "./ProductsStock.vue?vue&type=script&lang=js"
export * from "./ProductsStock.vue?vue&type=script&lang=js"
import style0 from "./ProductsStock.vue?vue&type=style&index=0&id=7eec5264&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports